<template>
    <div
        v-if="isLogin||(show&&showSkeleton)"
        v-loading="loading"
        :class="['vss-layout', pageData.isPhone ? 'phone' : 'pc', { 'u-scrollbar': showScrollbar }]"
    >
        <div class="menu-and-main-container">
            <!-- 仅供应商系统展示 -->
            <template v-if="accountTypeByPath === 0">
                <Notification v-if="!isLogin" />
                <InfoReminder v-if="!isLogin" />
                <FestivalCycleAdjustment
                    v-if="!isLogin"
                    :supplier-id="currentSupplier"
                />
            </template>
            <template v-if="accountTypeByPath === 1">
                <SalaryPayFailDlg v-if="!isLogin" />
            </template>
            <div
                v-if="!epassport && accountReady"
                :class="['main', {'no-left-menu': isLeftMenuHide}]"
            >
                <div
                    v-if="isBind"
                    class="crumb"
                >
                    <Breadcrumb />
                </div>
                <div
                    ref="content"
                    class="content layout-page-content"
                >
                    <template v-if="accountTypeByPath === 0">
                        <div
                            v-if="hasBind == 1"
                            slot="content"
                            style="padding: 10px;"
                        >
                            <el-alert
                                type="warning"
                                title="对不起，您还不是我公司正式供应商，无查看权限，请联系相关采购进行账号关联"
                                :closable="false"
                            />
                        </div>

                        <!-- 常规 -->
                        <slot
                            v-if="hasBind == 2 && settleVisible && supplierAuthControl === SUPPLIER_AUTH_STATE.YES "
                            name="content"
                        >
                        </slot>

                        <!-- 没绑定供货规则 -->
                        <div
                            v-if="hasBind == 1"
                            slot="content"
                            style="padding: 10px;"
                        >
                            <el-alert
                                v-if="settleVisible === false"
                                type="error"
                                title="您无权查看此页面"
                                :closable="false"
                            />
                        </div>

                        <!-- 无权限财务模块 -->
                        <el-alert
                            v-if="settleVisible === false"
                            type="error"
                            title="您无权查看此页面"
                            :closable="false"
                        />

                        <!-- 无该页面访问权限 -->
                        <NoAuth v-if="supplierAuthControl === SUPPLIER_AUTH_STATE.NO" />
                    </template>

                    <template v-if="accountTypeByPath === 1">
                        <slot name="content"></slot>
                    </template>
                </div>
            </div>
            <!-- 无该页面访问权限 -->
            <NoAuth v-if="supplierAuthControl === SUPPLIER_AUTH_STATE.NO" />
        </div>
        <Epassport v-if="epassport">
            <div
                slot="content"
                class="el-dialog-epassport"
            >
                <slot name="epassport"></slot>
            </div>
        </Epassport>
        <VssCourseDialog
            v-if="!isLogin"
            ref="vssCourseDialogRef"
            :course-type="COURSE_CONTROL_TYPE.FORCE"
            scene="ACTIVE"
            :menu-code="currentMenuCode"
        />
    </div>
</template>

<script>
import {
    getQuery, addWaterMarker, STATE_LINK_MAP, getSourceParamsFromSessionStorage, getMerchantState,
} from 'utils';
import Vue from 'vue';
import request from '@lsfe/components/utils/request-extra';
import { getSupplierInfoFromCache, clearSupplierInfoCache } from 'utils/supplierInfoManager';
import { reportMetric } from 'utils/reportMetric';
import { COURSE_CONTROL_TYPE, VSS_ACCOUNT_TYPE, SUPPLIER_AUTH_STATE } from './constants';
import NoAuth from './components/NoAuth';
import VssCourseDialog from './components/VssCourseDialog';
import Breadcrumb from './components/Breadcrumb';
import Epassport from './components/Epassport';
import InfoReminder from './components/InfoReminder';
import Notification from './components/Notification';
import SalaryPayFailDlg from './components/SalaryPayFailDlg';
import FestivalCycleAdjustment from './components/FestivalCycleAdjustment';
import { VSS_EVENTS } from './event';

const {
    redirect, source, entryPoint, ytType: ytTypeQuery, hzType: hzTypeQuery,
} = getQuery();
const { ytType: localYtType, hzType: localHzType } = getSourceParamsFromSessionStorage();

const ytType = ytTypeQuery || localYtType;
const hzType = hzTypeQuery || localHzType;

export default {
    components: {
        Breadcrumb,
        Epassport,
        VssCourseDialog,
        NoAuth,
        InfoReminder,
        Notification,
        SalaryPayFailDlg,
        FestivalCycleAdjustment,
    },
    props: {
        // 如果是登录页不调接口
        isLogin: {
            type: Boolean,
            default: false,
        },
        supplierSelectDisable: {
            type: Boolean,
            default: false,
        },
        needSignDiscipline: {
            type: Boolean,
            default: true,
        },
        // 是否展示供应商选择器
        showSupplierSelect: {
            type: Boolean,
            default: true,
        },
        // noMessage 此属性最终会传给HeaderMenu true 当前引用layout的地方不会有通知
    },
    provide() {
        return {
            // 设置通知栏刷新处理函数，用于通知栏刷新时调用
            setNoticeBarRefreshHandler: (handler) => {
                this.noticeBarRefreshHandler = handler;
            },
            // 刷新通知栏
            refreshNoticeBar: () => {
                if (typeof this.noticeBarRefreshHandler === 'function') {
                    this.noticeBarRefreshHandler();
                }
            },
        };
    },
    data() {
        return {
            noticeBarRefreshHandler: null,
            SUPPLIER_AUTH_STATE,
            COURSE_CONTROL_TYPE,
            VSS_ACCOUNT_TYPE,
            show: true,
            hasBind: 0, // 0:未开始, 1:未绑定 2:已绑定
            showScrollbar: !['Macintosh', 'iPhone', 'iPad'].some((v) => window.navigator.userAgent.includes(v)),
            settleVisible: null, // 展示结算模块
            epassport: 'epassport' in this.$slots,
            showSkeleton: false,
            accountMenu: [],
            accountType: '',
            accountTypeByPath: null,
            accountReady: false,
            login: '',
            supplierDxAccountVO: null,
            supplierInfo: {},
            currentMenuCode: null,
            supplierAuthControl: SUPPLIER_AUTH_STATE.PENDING, // 仅用于商品供应商的权限控制
            isLeftMenuHide: false,
            loading: false,
            currentSupplier: -1,
        };
    },
    computed: {
        accountMenuItem() {
            /**
             * 返回右上角用户信息菜单中的“切换账户类型”选项。
             */
            if (VSS_ACCOUNT_TYPE.length === 0) return {};
            return VSS_ACCOUNT_TYPE.find((item) => item.code === this.getAccountTypeByPath(true)) || {};
        },
        isBind() {
            if (this.accountTypeByPath !== 0) return true;
            return +this.hasBind === 2;
        },
    },
    watch: {
        currentSupplier(supplierId) {
            const headers = {
                'sqm-web-supplier-id': supplierId,
            };
            function fetchWrapper(method) {
                return function (url, param, options = {}) {
                    // Horn 不允许带自定义 header 的跨域请求
                    if (!/portal-portm\.meituan\.com/.test(url)) {
                        return request()[method](url, param, {
                            ...options,
                            headers: {
                                ...headers,
                                ...options.headers,
                            },
                        });
                    }
                    return request()[method](url, param, options);
                };
            }

            Vue.prototype.$get = fetchWrapper('get');
            Vue.prototype.$post = fetchWrapper('post');
            Vue.prototype.$hGet = fetchWrapper('hGet');
            Vue.prototype.$hPost = fetchWrapper('hPost');
        },
    },
    async created() {
        if (this.isLogin) {
            // 有几个页面不走下面逻辑，比如申请准入页等等
            return;
        }
        // iframe 中转站
        if (window.top !== window && redirect) {
            window.top.location.href = redirect || '/';
            this.show = false;
            return;
        }

        this.accountTypeByPath = this.getAccountTypeByPath();

        if (this.accountTypeByPath === 0) {
            // 侧边菜单数据
            const _menuRes = await this.$hPost('/api/vss/shepherd/supplier/auth/list', { source: 1 }).then((res) => res.menuInfoList).catch(() => false);

            if (!_menuRes) {
                this.$message.error('菜单加载失败');
                return;
            }

            this.showForceCourse({ _menuRes });
        }

        if (!this.epassport) {
            try {
                // const loading = this.$loading();
                this.loading = true;
                const promiseQueue = [
                    this.__getBizAccount().catch(() => ({})),
                ];

                if (this.accountTypeByPath === 0) {
                    // 仅商品
                    // 极少数情况:"劳动力账号访问到了非劳动力页面",也会冗余的调用这些用于商品供应商的接口，但是劳动力流量占比本来就非常少，大概0.1%，所以这里忽略掉。
                    // 这里为了确保其中有接口报错了，也不会影响整个promise.all的结果，所以每个请求都单独 catch 了返回空对象。
                    promiseQueue.push(
                        this.getAdmittanceNumber().catch(() => ({})),
                        this.__querySupplierInfoByBizAccountId().catch(() => ({})), // 这个接口，在没有供应商数据的时候会直接报错，且index中也使用了，并且原方法加了缓存，多注意！
                        getMerchantState({ ytType, hzType }).catch(() => ({})),
                    );
                }

                const promiseAllResponse = await Promise.all(promiseQueue).catch(() => {
                    this.showSkeleton = true;
                });

                if (!promiseAllResponse) {
                    this.$message.error('网络异常，请稍后重试');
                    return;
                }
                this.loading = false;
                // loading.close();

                const accountInfo = promiseAllResponse.shift();

                // 得到手机号，账户类型，账户名。
                const { phone, accountType, login } = accountInfo;
                this.login = login;
                this.accountType = accountType;

                // 校验当前路径是否符合当前登录人的账户类型, 如果不符合，就跳转到对应的账户类型页面。
                const isValidatePath = this.validatePath(accountType);
                if (!isValidatePath) return;

                this.accountReady = true;

                if (this.accountTypeByPath === 0) {
                    const [admittanceNumber, supplierInfoRes, merchantState] = promiseAllResponse;

                    // 【仅商品供应商】资质的id
                    const customerId = admittanceNumber;

                    // 【仅商品供应商】获取账号状态
                    const { state, needBusinessSelect } = merchantState || {};

                    this.accountStateProcess(customerId, state, needBusinessSelect);

                    this.supplierInfo = supplierInfoRes;

                    const cachedInfo = getSupplierInfoFromCache();
                    if (cachedInfo && cachedInfo.supplierId !== supplierInfoRes.supplierId) {
                        clearSupplierInfoCache();
                    }

                    localStorage.setItem('supplierInfo', JSON.stringify(this.supplierInfo));

                    // vss 的大象账号
                    this.supplierDxAccountVO = this.supplierInfo.supplierDxAccountVO;

                    this.hasBind = this.supplierInfo.supplierId > 0 ? 2 : 1;
                    if (this.hasBind === 2 && this.needSignDiscipline) {
                        // 认证和签署自律协议
                        this.checkDisciplineSign();
                    }

                    if (window.top.location.pathname.startsWith('/settlement')) {
                        this.showSettle();
                    } else {
                        this.settleVisible = true;
                    }
                } else {
                    // 劳动力供应商逻辑
                    this.showSkeleton = true;
                }

                this.$nextTick(() => {
                    if (this.$refs.content) {
                        addWaterMarker(this.$refs.content, phone);
                    }
                    this.$emit('loaded');
                });
            } catch (err) {
                this.showSkeleton = true;
                // eslint-disable-next-line no-console
                console.log(err);
            }
        }
    },
    mounted() {
        if (window.MC_MFE_APP && window.MC_MFE_APP.bridge) {
            const { bridge } = window.MC_MFE_APP;
            bridge.invoke(VSS_EVENTS.VSS_HEADER_SUPPLIER_SELECT, {
                supplierSelectDisable: this.supplierSelectDisable,
                showSupplierSelect: this.showSupplierSelect,
            });
            bridge.once(VSS_EVENTS.VSS_HEADER_SUPPLIER_CHANGE, (message) => {
                this.currentSupplier = message.supplierId;
            });
        }

        // 检测脱壳访问
        try {
            const currentPath = window.location.pathname;
            if (currentPath.includes('/vss/')) {
                reportMetric('vss_shell_access', {
                    path: currentPath,
                });
            }
        } catch (error) {
            console.error('上报失败:', error);
        }
    },
    methods: {
        async showForceCourse({ _menuRes }) {
            /**
             * 对商品供应商进行课程管控，如果有强管控课程的话，需要商家先上完课才能继续使用当前菜单对应的页面。
             */
            const currentPath = window.location.pathname;
            // 找出当前页面所对应的菜单项 code，首页由于历史原因，对"首页"稍做特殊处理。
            const currentMenuData = _menuRes.find((item) => (item.url && currentPath.split('.html')[0] === item.url) || (currentPath === '/' && item.url === '/index'));
            if (currentMenuData) {
                // 看一下当前 path 是否在 authList 中有配置 ，如果有才根据 value 卡控，没有就直接放行。
                if (currentMenuData.value === 0) {
                    this.supplierAuthControl = SUPPLIER_AUTH_STATE.NO;
                    return;
                }
                this.currentMenuCode = currentMenuData.code;
                await this.$nextTick();
                await this.checkForceCourse();
            }
            this.supplierAuthControl = SUPPLIER_AUTH_STATE.YES;
        },
        productLeftMenuToggleHandler(data) {
            this.isLeftMenuHide = !data;
        },
        async checkForceCourse() {
            const res = await this.$hPost('/api/vss/shepherd/announcement/queryVss', {
                force: 1, // 强管控
                type: 2, // 0-普通通知, 1-预警通知, 2-课程通知
                paging: {
                    offset: 0, limit: 1,
                },
                menuCode: this.currentMenuCode,
            });
            if (res.total > 0) {
                // 如果有强管控课程，就弹出窗口。
                setTimeout(() => {
                    if (this.$refs.vssCourseDialogRef) {
                        this.$refs.vssCourseDialogRef.init();
                    } else {
                        console.log(this.$refs.vssCourseDialogRef, this.isLogin, 'no');
                    }
                }, 500);
            }
        },
        getAdmittanceNumber() {
            // 当前供应商是否处于“供应商填写准入信息并且没有绑定供应商”, 处于这种情况的跳转到准入表单填写页面。
            const out = this.$hPost('/api/vss/second/shepherd/sqm/SupplierCertTService/getAdmittanceNoByVssPhone');
            return out;
        },
        async accountStateProcess(customerId, state, needBusinessSelect) {
            // 账号状态处理，包含一些自动跳转逻辑
            // 当前供应商是否处于“供应商填写准入信息并且没有绑定供应商”, 处于这种情况的跳转到准入表单填写页面。
            if (customerId) {
                await this.$alert(
                    '请填写供应商准入信息',
                    {
                        showClose: false,
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                        closeOnHashChange: false,
                    },
                );
                this.$tools.linkTo('/info/supplierApply.html', { customerId });
            } else {
                if (needBusinessSelect) {
                    this.$tools.linkTo('/vss/supplier/businessSelect.html', { from: 'login' });
                } else if (STATE_LINK_MAP[state]) {
                    this.$tools.linkTo(STATE_LINK_MAP[state], { source, entryPoint });
                }
                // 999, 表示已签合同，已绑定供货规则。
                this.showSkeleton = true;
            }
        },
        async showSettle() {
            const rule = await this.$hGet('/api/m/vss/settlement/query/settlement/rule', {}, { cache: true });
            // 对账方式 0: 我方发起, 1: 供应商发起
            // 我方发起 => 不展示结算模块
            this.settleVisible = rule && rule.accountWay === 1;
        },
        async checkDisciplineSign() {
            const res = await this.$hPost('/api/vss/second/shepherd/selfdiscipline/querysignstatus');

            if ([2, 3].includes(res && res.status)) {
                const hasCa = res && res.status === 2;
                const h = this.$createElement;
                this.$msgbox({
                    title: '《廉洁自律书》线上签署提醒',
                    message: h('div', null, [
                        h('p', null, '各位供应商伙伴，廉洁合作是我们彼此获得双赢的重要基础，为加强您对美团的廉正感知，营造廉洁的营商环境，请在线完成《廉洁自律书》签署，谢谢合作'),
                        !hasCa ? h('p', { class: 'xx-text-danger' }, '您尚未进行ca认证，请前往相关单位或网站认证后再进行签署') : '',
                    ]),
                    showConfirmButton: hasCa,
                    showCancelButton: !hasCa,
                    confirmButtonText: '立即签署',
                    cancelButtonText: '关闭',
                    showClose: true,
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    closeOnHashChange: false,
                    beforeClose: (action, instance, done) => {
                        if (action === 'confirm') {
                            // 签署自律书
                            this.$tools.linkTo('/vss/content/discipline/sign.html');
                            return done();
                        }

                        // 未签署ca协议 直接关闭
                        return done();
                    },
                });
            }
        },
        validatePath(accountType) {
            /**
             * @accountType 登录人拥有：0商户账户 1劳动力商户账户 2商户账户&劳动力商户
             * */
            if (accountType !== 2 && accountType !== this.getAccountTypeByPath()) {
                const { to } = VSS_ACCOUNT_TYPE.find(({ code }) => code === accountType);
                this.$tools.linkTo(to);
                return false;
            }
            return true;
        },
        getAccountTypeByPath(toggle) {
            const pathname = window.top.location.pathname;
            // /renxiao和/micro/lmsplat开头路径都为劳动力商合法路径
            if (/^\/renxiao|^\/micro\/lmsplat/.test(pathname)) {
                return !toggle ? 1 : 0;
            } else {
                return !toggle ? 0 : 1;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.vss-layout {
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: auto;
    .main {
        flex: 1;
        position: relative;
        transition: all 0.2s;
        &.no-left-menu {
            margin-left: 20px;
        }
    }
    .crumb {
        padding: 0 10px;
        background-color: #fff;
        border-top: 1px solid #eee;
        box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.08);
        &:empty {
            display: none;
        }
    }
    .layout-page-content {
        padding: 10px;
    }

    .el-submenu__icon-arrow:before {
        content: "\E60B";
    }

    // #858692
    .el-breadcrumb__inner,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner,
    .el-breadcrumb__inner a {
        color: #858692;
        font-weight: normal;
    }
}
</style>

<style>
.el-dialog-epassport,
.el-dialog-epassport > div {
    height: 100%;
}
</style>
